import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import AlertModalContainer from '@components/AlertModalContainer';

import './DeleteAlertModal.scss';

class DeleteAlertModal extends PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    cancelDelete: PropTypes.func.isRequired,
    confirmDelete: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired
  };

  render() {
    return (
      <AlertModalContainer
        isOpen={this.props.isOpen}
        handleCancel={this.props.cancelDelete}
        handleAccept={this.props.confirmDelete}
        isLoading={this.props.isLoading}
        isDelete
        hasCancelButton
      >
        <div className="delete-form__title">
          {trans('alerts.modal.delete.title')}
        </div>
        <p
          className="delete-form__content"
          dangerouslySetInnerHTML={{
            __html: trans('alerts.modal.delete.body')
          }}
        />
      </AlertModalContainer>
    );
  }
}

export default DeleteAlertModal;
